export const REGISTRATION_STEPS = [
  "1. GENERAL",
  "2. ADDITIONAL INFO",
  "3. INTERESTS SETUP",
  "4. NDA EXECUTION",
];
